<template>
  <div class="row">
    <div class="col-md-12 PageToolbar" style="padding-top: 8px">
      <vonap-toolbar-label label="Currency">
        <div ref="ccyPairDropDownList" style="width: 100px"></div>
        <label ref="ccyPairLabel"> {{ underlying }}</label>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Cashflow Type">
        <div ref="flowTypeDropDownList" style="width: 210px"></div>
      </vonap-toolbar-label>
      <vonap-toolbar-label label="Cashflow Date">
        <div ref="datesDropDownList" style="width: 125px"></div>
      </vonap-toolbar-label>
      <span style="padding-left: 8px; position: relative; top: -6px">
        <a ref="addNewButton" title="Add new Forecast"></a>
        <a ref="deleteButton" title="Delete Forecast"></a>
      </span>

      <div ref="excelButton" style="width: 40px"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import forecastDateWindow from './List/DivisionForecast/forecastDateWindow'
import hedgePolicyDateWindow from './Config/HedgePolicy/dateWindow'
import notification from '@/helpers/notification'
import confirmationWindow from '../helpers/confirmation-window'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import axios from 'axios'

const $ = kendo.jQuery
export default {
  components: {
    VonapToolbarLabel,
  },
  props: {
    source: {type: String, default: 'DivisionForecast'},
    numberOfPeriods: {type: Number, default: 12},
    isReadOnly: {type: Boolean, default: true},
    marketId: {type: Number, default: -1},
  },
  data() {
    return {
      ccyPairId: -1,
      exposureCcy: '',
      foreignCcyMarketId: -1,
      underlying: '',
      flowTypeId: -1,
      typeNumId: -1,
      date: new Date(),
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  mounted() {
    const dropDownList = this.getCcyPairDropDownList()

    dropDownList.then(() => {
      this.getFlowTypeDropDownList().then(() => {
        this.getDatesDropDownList().then(() => {
          this.$emit('change', {
            clientId: this.clientId,
            ccyPairId: this.ccyPairId,
            marketId: this.foreignCcyMarketId,
            exposureCcy: this.exposureCcy,
            underlying: this.underlying,
            flowTypeId: this.flowTypeId,
            typeNumId: this.typeNumId,
            date: this.date,
          })
        })
      })
    })

    $(this.$refs.addNewButton)
      .off('click')
      .kendoButton({
        icon: 'k-icon k-i-calendar-date',
        click: () => {
          const datesDropDownList = $(this.$refs.datesDropDownList).getKendoDropDownList()
          const invalidDates = datesDropDownList.dataSource
            .data()
            .filter(function(element) {
              return element.dateText !== 'New Date'
            })
            .map(function(element) {
              return kendo.toString(element.date, 'yyyy-MM-dd')
            })

          if (this.source == 'Forecast' || this.source == 'DivisionForecast') {
            forecastDateWindow.openCashFlowDivisionForecast(
              this.clientId,
              this.flowTypeId,
              this.ccyPairId,
              this.exposureCcy,
              invalidDates,
              this.numberOfPeriods,
            )
            forecastDateWindow.onSaveChanges(function() {
              datesDropDownList.dataSource.read().then(function() {
                datesDropDownList.trigger('change')
              })
            })
          }

          if (this.source == 'HedgePolicy') {
            hedgePolicyDateWindow.openWindow(
              this.clientId,
              this.ccyPairId,
              this.flowTypeId,
              invalidDates,
              this.numberOfPeriods,
            )
            hedgePolicyDateWindow.onSaveChanges(function() {
              datesDropDownList.dataSource.read().then(function() {
                datesDropDownList.trigger('change')
              })
            })
          }
        },
      })

    $(this.$refs.deleteButton)
      .off('click')
      .kendoButton({
        icon: 'k-icon k-i-calendar',
        click: () => {
          let title = 'FX Rates'
          let message = 'Delete ' + this.date + ' Forecast'
          let deleteUrl = '/api/list/divisionforecast/deleteCashFlowDivisionForecastDate'
          let parameters = {
            forecastDate: this.date,
            clientId: this.clientId,
            ccyPairId: this.ccyPairId,
            exposureCcy: this.exposureCcy,
            flowTypeId: this.flowTypeId,
          }

          if (this.source == 'HedgePolicy') {
            title = 'Hedge Policy'
            deleteUrl = '/api/config/hedgepolicy/deleteHedgePolicyDate'
            message = 'Delete ' + this.date + ' Hedge Policy'
            parameters = {
              clientId: this.clientId,
              ccyPairId: this.ccyPairId,
              flowTypeId: this.flowTypeId,
              hedgePolicyDate: this.date,
            }
          }

          const datesDropDownList = $(this.$refs.datesDropDownList).getKendoDropDownList()
          confirmationWindow.openConfirmationWindow(title, message, () => {
            axios.delete(deleteUrl, {params: parameters}).then(function() {
              notification('Record deleted successfully', 'info')
              datesDropDownList.dataSource.read().then(function() {
                datesDropDownList.trigger('change')
              })
            })
          })
        },
      })

    if (this.isReadOnly) {
      $(this.$refs.deleteButton).hide()
      $(this.$refs.addNewButton).hide()
    } else {
      $(this.$refs.deleteButton).show()
      $(this.$refs.addNewButton).show()
    }
  },
  methods: {
    getCcyPairDropDownList() {
      const vm = this
      return new Promise(resolve => {
        $(this.$refs.ccyPairDropDownList).kendoDropDownList({
          filter: 'contains',
          dataTextField: 'ccyPair',
          dataValueField: 'ccyPairId',
          dataSource: {
            transport: {
              read: {
                type: 'GET',
                contentType: 'application/json',
                url: '/api/FlowTypeToolbar/getCcyPairs',
                data: () => ({clientId: this.clientId, marketId: this.marketId}),
              },
            },
          },
          index: 0,
          change: e => {
            vm.ccyPairId = e.sender.value()
            vm.foreignCcyMarketId = e.sender.dataItem().marketId
            vm.exposureCcy = e.sender.dataItem().exposureCcy
            vm.underlying = e.sender.dataItem().underlying

            const datesDropDownList = $(this.$refs.datesDropDownList).getKendoDropDownList()

            datesDropDownList.dataSource.read().then(function() {
              datesDropDownList.select(0)
              datesDropDownList.trigger('change')
            })
          },
          dataBound: function() {
            this.select(0)
            vm.ccyPairId = this.value()
            vm.foreignCcyMarketId = this.dataItem().marketId
            vm.exposureCcy = this.dataItem().exposureCcy
            vm.underlying = this.dataItem().underlying
            resolve()
          },
        })
      })
    },
    getFlowTypeDropDownList() {
      const vm = this
      return new Promise(resolve => {
        $(this.$refs.flowTypeDropDownList).kendoDropDownList({
          dataTextField: 'flowTypeName',
          dataValueField: 'flowTypeId',
          dataSource: {
            transport: {
              read: {
                type: 'GET',
                contentType: 'application/json',
                url: '/api/flowTypeToolbar/getFlowTypes',
                data: () => ({clientId: this.clientId}),
              },
            },
          },
          index: 0,
          change: e => {
            vm.flowTypeId = e.sender.value()
            const {typeNumId} = e.sender.dataItem()
            vm.typeNumId = typeNumId
            const datesDropDownList = $(vm.$refs.datesDropDownList).getKendoDropDownList()
            datesDropDownList.dataSource.read().then(function() {
              datesDropDownList.select(0)
              datesDropDownList.trigger('change')
            })
          },
          dataBound: function(e) {
            this.select(0)
            vm.flowTypeId = this.value()
            const {typeNumId} = e.sender.dataItem()
            vm.typeNumId = typeNumId

            resolve()
          },
        })
      })
    },
    getDatesDropDownList() {
      const vm = this
      let dropdownUrl = '/api/flowTypeToolbar/getDates'
      if (vm.source == 'HedgePolicy') {
        dropdownUrl = '/api/flowTypeToolbar/getHedgePolicyDates'
      } else if (vm.source == 'Forecast') {
        dropdownUrl = '/api/flowTypeToolbar/getForecastDates'
      }

      return new Promise(resolve => {
        const dropDownList = $(this.$refs.ccyPairDropDownList).getKendoDropDownList()
        const flowTypeDropDownList = $(this.$refs.flowTypeDropDownList).getKendoDropDownList()
        $(this.$refs.datesDropDownList).kendoDropDownList({
          filter: 'contains',
          dataTextField: 'dateText',
          dataValueField: 'dateValue',
          dataSource: {
            transport: {
              read: {
                type: 'GET',
                url: dropdownUrl,
                contentType: 'application/json',
                data: () => {
                  return {
                    clientId: this.clientId,
                    ccyPairId: dropDownList.value(),
                    flowTypeId: flowTypeDropDownList.value(),
                  }
                },
              },
            },
            schema: {
              model: {
                fields: {
                  date: {type: 'date'},
                },
              },
            },
          },
          index: 0,
          change: function(e) {
            vm.date = e.sender.value()
            vm.$emit('change', {
              clientId: vm.clientId,
              ccyPairId: vm.ccyPairId,
              marketId: vm.foreignCcyMarketId,
              exposureCcy: vm.exposureCcy,
              underlying: vm.underlying,
              flowTypeId: vm.flowTypeId,
              typeNumId: vm.typeNumId,
              date: vm.date,
            })
          },
          dataBound: function() {
            this.select(0)
            vm.date = this.value()
            if (vm.date == '0001-01-01') {
              $(vm.$refs.deleteButton).hide()
            }
            resolve()
          },
        })
      })
    },
  },
}
</script>

<style scoped>
label {
  display: inline-block;
  padding: 0 5px;
}

.disabledDay {
  display: block;
  overflow: hidden;
  min-height: 22px;
  line-height: 22px;
  padding: 0 0.45em 0 0.1em;
  cursor: default;
  opacity: 0.5;
}
</style>
